(() => {
  if (window.mcCardQuickAddReady) return;
  window.mcCardQuickAddReady = true;

  const closeSheet = (component) => {
    const dialog = component?.querySelector('dialog');
    if (dialog?.open) dialog.close();
    document.body.classList.remove('mc-quick-add-open');
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-mc-quick-add-open]');
    if (openButton) {
      const component = openButton.closest('mc-card-quick-add');
      const dialog = component?.querySelector('dialog');
      if (dialog) {
        dialog.showModal();
        document.body.classList.add('mc-quick-add-open');
      }
      return;
    }

    const closeButton = event.target.closest('[data-mc-quick-add-close]');
    if (closeButton) {
      closeSheet(closeButton.closest('mc-card-quick-add'));
      return;
    }

    const submitButton = event.target.closest('[data-mc-quick-add-submit]');
    if (!submitButton || submitButton.disabled) return;

    const component = submitButton.closest('mc-card-quick-add');
    const form = component?.querySelector('product-form form');
    if (!form) return;

    event.preventDefault();
    closeSheet(component);
    requestAnimationFrame(() => form.requestSubmit(submitButton));
  });

  document.addEventListener('change', (event) => {
    const sizeInput = event.target.closest('[data-mc-quick-add-size]');
    if (!sizeInput) return;

    const component = sizeInput.closest('mc-card-quick-add');
    const variantInput = component?.querySelector('[data-mc-quick-add-variant]');
    const submitButton = component?.querySelector('[data-mc-quick-add-submit]');
    if (!variantInput || !submitButton) return;

    variantInput.value = sizeInput.value;
    variantInput.disabled = false;
    submitButton.disabled = false;
  });

  document.addEventListener(
    'cancel',
    (event) => {
      const component = event.target.closest('mc-card-quick-add');
      if (!component) return;
      event.preventDefault();
      closeSheet(component);
    },
    true
  );
})();
